import { Combobox } from '@components/combobox/Combobox';
import { useVipTiers } from 'restaurantAdmin/hooks/useVipTiers';
import styles from './GuestVipTierCombobox.scss';

export interface VipTierOption {
  id: string;
  name: string;
}

interface GuestVipTierComboboxProps {
  onChange: (value: VipTierOption | null) => void;
  value: VipTierOption | null;
}

export const GuestVipTierCombobox = ({
  onChange,
  value,
}: GuestVipTierComboboxProps) => {
  const { data: vipTiers = [] } = useVipTiers();

  const options: VipTierOption[] = vipTiers.map((tier) => ({
    id: tier.id,
    name: tier.name,
  }));

  return (
    <div className={styles.container}>
      <Combobox
        aria-label="Guest VIP Tier"
        allowOptionCreate={false}
        getOptionLabel={(tier) => tier.name}
        onChange={(selected) => {
          // A guest can hold only one tier, so we keep the most recent choice.
          const latest = selected[selected.length - 1];
          onChange(typeof latest === 'object' ? latest : null);
        }}
        options={options}
        placeholder="Select VIP Tier"
        popupClassName={styles.popup}
        value={value ? [value] : []}
      />
    </div>
  );
};
